import * as React from "react";

import { cn } from "../../cn";
import { formControlInputClass } from "../../styles/form-control";

import type { TestIdProps } from "./types";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement>,
    TestIdProps {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, testId, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(formControlInputClass, className)}
        ref={ref}
        data-testid={testId}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
